import { createContext, useContext, useState, useEffect } from 'react';

const OnlineContext = createContext();

export function OnlineProvider({ children }) {
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return (
        <OnlineContext.Provider value={{ isOnline }}>
            {children}
        </OnlineContext.Provider>
    );
}

export function useOnline() {
    const context = useContext(OnlineContext);
    if (!context) {
        throw new Error('useOnline must be used within an OnlineProvider');
    }
    return context;
} 